import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>Unity Game Development Company</h1>
              <p>
                Struggling to find a Unity game development company you can
                truly rely on? Look no further! TekRevol is here to solve your
                challenge.We specialize in delivering top-notch solutions that
                bring your gaming ideas to life.Our dedicated team of experts to
                guide you through every step of the process, ensuring that your
                vision transforms into captivating Unity games.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let's Build Your Game Now!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/game/banner-game.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
